import Vue from 'vue'
import VueRouter from 'vue-router'
// 自定义的工具库，用于操作 Cookie
import cookieUtil from '@/common/cookie-util'
import store from '@/store'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/login',
    meta: {
      title: '登录页',
      hideInMenu: true
    },
    component: () => import('@/views/login/login.vue')
  }
]
const createRouter = () => new VueRouter({
  mode: 'hash',
  routes
})
const router = createRouter();

// 添加路由重置方法（开发环境热更新时使用）
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}
router.beforeEach((to, from, next) => {
  const token = cookieUtil.getToken()
  if (token) {
    store.dispatch('app/getMenuList')
  }
  if (!token && to.path !== '/login' && !to.meta.whiteRoute) {
    next('/login')
  } else if (token && to.path === '/login') {
    store.dispatch('app/getMenuList')
    next('/')
  } else if (token && to.path === '/') {
    next('/system/role')
  } else {
    next()
  }
})

export default router
